export default __webpack_public_path__ + "static/hero-video-s4-5dc63ed842c45fbac174d0dfe7f07e5a.jpg";